<mat-nav-list>
  <mat-list-item>
    <div matLine>Causable Admin</div>
  </mat-list-item>
  <hr class="white-text">
  <mat-expansion-panel data-testid="causable-admin-features-panel" *userHasCausableAdminAccess>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="margin-right-med">engineering</mat-icon>
        <span>Causable Admin Features</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list-item [routerLink]="['testing-page']"
                   *userHasCausableAdminAccess
                   data-testid="testing-page-link">
      <mat-icon matListItemIcon>checklist</mat-icon>
      <div matLine>Testing</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['signal-r-connections']"
                   *userHasCausableAdminAccess
                   data-testid="signal-r-page-link">
      <mat-icon matListItemIcon>checklist</mat-icon>
      <div matLine>Signal R Connections</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['view-player-emails']"
                   *userHasCausableAdminAccess
                   data-testid="game-instance-player-emails-link">
      <mat-icon matListItemIcon>email</mat-icon>
      <div matLine data-testid="sidenav-current-draw">Game Instance Player Emails</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['sendgrid-events']"
                   *userHasCausableAdminAccess
                   data-testid="sendgrid-events-link">
      <mat-icon matListItemIcon>email</mat-icon>
      <div matLine data-testid="sidenav-sendgrid-events">SendGrid Events</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['new-game']"
                   *userHasCausableAdminAccess
                   data-testid="new-game-page-link">
      <mat-icon matListItemIcon>add</mat-icon>
      <div matLine data-testid="sidenav-new-game">New Game</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['profanity-filter-manager']"
                   data-testid="profanity-filter-manager-page-link"
                   *userHasCausableAdminAccess>
      <mat-icon matListItemIcon>lock</mat-icon>
      <div matLine data-testid="sidenav-profanity-filter-manager">Profanity Filter Manager</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['error-category-management']"
                   data-testid="error-category-management-page-link"
                   *hasPermission="permissionTypes.ViewSystemErrorMessages">
      <mat-icon matListItemIcon>error_outline</mat-icon>
      <div matLine data-testid="sidenav-error-category-management">Error Category Management</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['manage-global-permissions']"
                   data-testid="manage-permissions-page-link"
                   *userHasCausableAdminAccess>
      <mat-icon matListItemIcon>manage_accounts</mat-icon>
      <div matLine data-testid="sidenav-manage-permissions">Manage Global Permissions</div>
    </mat-list-item>

    @if (hangfireDashboardLink) {
      <a [href]="hangfireDashboardLink" target="_blank" style="text-decoration: none;">
        <mat-list-item data-testid="hangfire-dashboard-link" *userHasCausableAdminAccess>
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <div matLine data-testid="sidenav-hangfire-dashboard">Hangfire Dashboard</div>
        </mat-list-item>
      </a>
    }

    <mat-list-item data-testid="logging-level-switch-link" [routerLink]="['log-level-switch']" *userHasCausableAdminAccess>
      <mat-icon matListItemIcon>bug_report</mat-icon>
      <div matLine data-testid="sidenav-logging-level-switch">Logging Level Switch</div>
    </mat-list-item>

    <mat-list-item data-testid="file-integrity-dashboard-link" [routerLink]="['file-integrity-dashboard']" *userHasCausableAdminAccess>
      <mat-icon matListItemIcon>security</mat-icon>
      <div matLine data-testid="sidenav-file-integrity-dashboard">File Integrity Dashboard</div>
    </mat-list-item>

    <mat-list-item data-testid="admin-terms-link" [routerLink]="['privacy-policy']" *userHasCausableAdminAccess>
      <mat-icon matListItemIcon>description</mat-icon>
      <div matLine data-testid="sidenav-admin-terms">Admin Terms</div>
    </mat-list-item>

    <mat-list-item data-testid="manage-region-tax-rates-link" [routerLink]="['manage-region-tax-rates']" *userHasCausableAdminAccess>
      <mat-icon matListItemIcon>percent</mat-icon>
      <div matLine data-testid="sidenav-manage-region-tax-rates">Manage Region Tax Rates</div>
    </mat-list-item>

  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header data-testid="view-cross-game-admin-menu-options">
      <mat-panel-title>
        <mat-icon class="margin-right-med">build</mat-icon>
        <span>Game Management</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list-item [routerLink]="['cross-game-view-draw-landing']"
                   data-testid="view-active-draw-page-link">
      <mat-icon matListItemIcon>sports_esports</mat-icon>
      <div matLine data-testid="sidenav-current-draw">Manage Active Draws</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['cross-game-winner-payouts']"
                   data-testid="view-winner-payout-page-link">
      <mat-icon matListItemIcon>account_balance_wallet</mat-icon>
      <div matLine data-testid="sidenav-current-draw">Manage Winner Payouts</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['cross-game-charity-payouts']"
                   data-testid="view-charity-payout-page-link"
                   *hasPermission="permissionTypes.ViewCharityPayouts">
      <mat-icon matListItemIcon>payments</mat-icon>
      <div matLine data-testid="sidenav-charity-payouts">Charity Payouts</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['cross-game-game-management']"
                   data-testid="cross-game-sidenav-game-settings">
      <mat-icon matListItemIcon>settings</mat-icon>
      <div matLine data-testid="sidenav-current-draw">View Game Settings</div>
    </mat-list-item>
    <mat-list-item [routerLink]="['cross-game-draw-winner']"
                   data-testid="draw-winner-page-link"
                   *hasPermission="permissionTypes.DrawGameWinner"
                   matTooltip="Draw Winner"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>celebration</mat-icon>
      <div matLine data-testid="sidenav-draw-winner">Draw Winner</div>
    </mat-list-item>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header data-testid="manage-your-account-side-nav-option">
      <mat-panel-title>
        <mat-icon class="margin-right-med">account_circle</mat-icon>
        <span>Manage Your Account</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list-item [routerLink]="['update-email-address']"
                   data-testid="navigate-to-change-email-page">
      <mat-icon matListItemIcon>email</mat-icon>
      <div matLine>Change Your Email</div>
    </mat-list-item>

    <mat-list-item [routerLink]="['update-password']"
                   data-testid="navigate-to-change-password-page">
      <mat-icon matListItemIcon>password</mat-icon>
      <div matLine>Change Your Password</div>
    </mat-list-item>
  </mat-expansion-panel>

  <mat-list-item [routerLink]="['cross-game-admin-reporting']"
                 data-testid="view-cross-game-reporting-page-link">
    <mat-icon matListItemIcon>request_page</mat-icon>
    <div matLine data-testid="sidenav-current-draw">Reporting</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['cross-game-charities']"
                 *hasPermission="permissionTypes.ViewCharities"
                 data-testid="view-cross-game-charity-page-link">
    <mat-icon matListItemIcon>volunteer_activism</mat-icon>
    <div matLine data-testid="sidenav-current-draw">Charities</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['cross-game-notification-preferences']"
                 data-testid="notification-preferences-page-link">
    <mat-icon matListItemIcon>notification_add</mat-icon>
    <div matLine data-testid="sidenav-notification-preferences">Notification Preferences
    </div>
  </mat-list-item>

    <mat-list-item [routerLink]="['cross-game-support-desk-search']"
                   *hasPermission="permissionTypes.ViewSupportRequests"
                   data-testid="causable-admin-support-desk-link">
      <mat-icon matListItemIcon
                [matBadge]="assignedSupportRequestsCount()"
                matBadgeColor="warn"
                [matBadgeHidden]="assignedSupportRequestsCount() === 0"
                aria-hidden="false">support_agent
      </mat-icon>
      <div matLine data-testid="causable-admin-support-desk">Global Support Desk</div>
    </mat-list-item>


  <mat-list-item [routerLink]="['global-player-search']"
                 *hasPermission="permissionTypes.ViewGlobalPlayerSearch"
                 data-testid="global-player-search">
    <mat-icon matListItemIcon>settings</mat-icon>
    <div matLine data-testid="sidenav-global-search">Global Player Search</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['payment-methods']"
                 *hasPermission="permissionTypes.ViewPlayerInfo"
                 data-testid="payment-methods-page-link">
    <mat-icon matListItemIcon>credit_card</mat-icon>
    <div matLine data-testid="sidenav-payment-methods">Payment Methods</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['email-history']"
                 *hasPermission="permissionTypes.ViewPlayerInfo"
                 data-testid="email-history">
    <mat-icon matListItemIcon>email</mat-icon>
    <div matLine data-testid="sidenav-email-history">Email History</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['auditing']"
                 *hasPermission="permissionTypes.ViewAuditing"
                 data-testid="auditing-page-link">
    <mat-icon matListItemIcon>edit</mat-icon>
    <div matLine data-testid="sidenav-auditing">Auditing</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['error-debugging']"
                 *hasPermission="permissionTypes.ViewAuditing"
                 data-testid="error-debugging-page-link">
    <mat-icon matListItemIcon>bug_report</mat-icon>
    <div matLine data-testid="sidenav-error-debugging">Error Debugging</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['manage-cross-game-users']"
                 data-testid="manage-users-page-link"
                 *hasPermission="permissionTypes.ViewAdminUsers">
    <mat-icon matListItemIcon>supervised_user_circle</mat-icon>
    <div matLine data-testid="sidenav-admin-user">Admin Users</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['player-email-confirmations']"
                 data-testid="player-email-confirmations-page-link"
                 *hasPermission="permissionTypes.ViewEmailConfirmations">
    <mat-icon matListItemIcon>email</mat-icon>
    <div matLine data-testid="sidenav-player-email-confirmations">Player Email Confirmations</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['manage-broadcast-notifications']"
                 data-testid="manage-broadcast-notifications-page-link"
                 *hasPermission="permissionTypes.ViewBroadcastNotifications">
    <mat-icon matListItemIcon>campaign</mat-icon>
    <div matLine data-testid="sidenav-broadcast-notifications">Broadcast Notifications</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['failed-refunds']"
                 data-testid="failed-refunds-page-link"
                 *hasPermission="permissionTypes.ViewFailedRefunds">
    <mat-icon matListItemIcon>error</mat-icon>
    <div matLine data-testid="sidenav-failed-refunds">Failed Refunds</div>
  </mat-list-item>

  <mat-list-item [routerLink]="['frequently-asked-questions']"
                 data-testid="faq-page-link">
    <mat-icon matListItemIcon>question_mark</mat-icon>
    <div matLine data-testid="sidenav-current-draw">Frequently Asked Questions</div>
  </mat-list-item>

  <mat-list-item data-testid="user-menu-logout-button" (click)="onLogoutClick();">
    <mat-icon matListItemIcon>logout</mat-icon>
    <div matLine>Log out</div>
  </mat-list-item>
</mat-nav-list>
